(() => {
  document.querySelectorAll('.bd-category-rail').forEach(rail => {
    if (rail.dataset.bound) return;
    rail.dataset.bound = 'true';
    const nav = rail.querySelector('.bd-category-nav');
    const buttons = Array.from(rail.querySelectorAll('.bd-category-arrow'));
    let frame = 0, timer = 0, previous = 0, direction = 0;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const stop = () => {
      clearTimeout(timer); cancelAnimationFrame(frame);
      frame = 0; previous = 0; direction = 0;
    };
    const update = () => {
      buttons[0].disabled = nav.scrollLeft <= 1;
      buttons[1].disabled = nav.scrollLeft >= nav.scrollWidth - nav.clientWidth - 1;
    };
    const tick = time => {
      if (!rail.isConnected || !direction) { stop(); return; }
      const before = nav.scrollLeft;
      nav.scrollLeft += direction * Math.min(time - (previous || time), 32) * 0.28;
      previous = time;
      update();
      if (nav.scrollLeft === before && before === (direction < 0 ? 0 : nav.scrollWidth - nav.clientWidth)) { stop(); return; }
      frame = requestAnimationFrame(tick);
    };
    buttons.forEach(button => {
      button.addEventListener('pointerenter', event => {
        stop();
        if (event.pointerType !== 'mouse' || button.disabled || reduced.matches) return;
        timer = setTimeout(() => { direction = Number(button.dataset.direction); frame = requestAnimationFrame(tick); }, 250);
      });
      button.addEventListener('pointerleave', stop);
      button.addEventListener('pointerdown', stop);
      button.addEventListener('click', () => {
        stop();
        nav.scrollBy({left:Number(button.dataset.direction) * nav.clientWidth * 0.65, behavior:reduced.matches ? 'instant' : 'smooth'});
      });
    });
    rail.addEventListener('pointerleave', stop);
    nav.addEventListener('scroll', update, {passive:true});
    window.addEventListener('blur', stop);
    document.addEventListener('visibilitychange', stop);
    new ResizeObserver(update).observe(nav);
    new MutationObserver(() => {
      const active = nav.querySelector('.is-active');
      if (active) {
        const nr = nav.getBoundingClientRect(), ar = active.getBoundingClientRect();
        if (ar.left < nr.left || ar.right > nr.right) nav.scrollLeft += ar.left - nr.left - 4;
      }
      update();
    }).observe(nav, {subtree:true, attributes:true, attributeFilter:['aria-current']});
    update();
  });
})();
